// Font loader — copy of frontend/src/utils/fontLoader.js so the admin
// order-template editor renders textboxes in the real uploaded faces.
// Keep the two files in sync.

const loaded = new Set();

export async function loadFont(name, url, weight = '400') {
  const key = `${name}-${weight}`;
  if (loaded.has(key)) return;
  try {
    const face = new FontFace(name, `url(${url})`, { weight: String(weight) });
    await face.load();
    document.fonts.add(face);
    loaded.add(key);
  } catch (e) {
    console.warn('Font load failed:', name, url, e.message);
  }
}

export async function loadFontsForFields(fields, catalog) {
  const names = new Set(fields.map(f => f.fontFamily).filter(Boolean));
  const tasks = [];
  for (const name of names) {
    const matches = (catalog || []).filter(c => c.name === name && c.path);
    if (matches.length === 0) continue;
    for (const m of matches) tasks.push(loadFont(name, m.path, m.weight || '400'));
  }
  await Promise.all(tasks);
  if (typeof document !== 'undefined' && document.fonts && document.fonts.ready) {
    try { await document.fonts.ready; } catch (_) {}
  }
}
